<template>
    <v-content>
        <v-card>
            <v-toolbar color="secondary" dark v-if="graphdata" :style="$store.state.textFormatting.headers">
                {{statCall}} In {{tableinfo.length}} intervals for {{tableinfo.interval}} interval(s)
            </v-toolbar>
            <v-flex xs12>
                <bar-chart v-if="graphdata" :chart-data="graphdata" :options="options"></bar-chart>
            </v-flex>
            <v-card-text v-if="isNotDashboard">
                <v-layout wrap row>           
                    <v-layout row wrap justify-center>
                        <v-flex md12 xs12>
                            <v-select :style="$store.state.textFormatting.main" v-model="statCall" :items="statType" :rules="[v => !!v || 'Item is required']" label="Stat type" required></v-select>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-select :style="$store.state.textFormatting.main" v-model="selectLength" :items="ILength" :rules="[v => !!v || 'Item is required']" label="Interval Length" required></v-select>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-select :style="$store.state.textFormatting.main" v-model="selectCount" :items="IInterval" :rules="[v => !!v || 'Item is required']" label="Number of Intervals" required></v-select>
                            <!-- <v-slider v-model="selectCount" thumb-label="always" min="1" max="10" ></v-slider> -->
                        </v-flex>
                        <v-flex md3 xs12>
                            <v-btn @click="getdata()" :style="$store.state.textFormatting.main"> Submit </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-progress-circular v-if="loading" indeterminate color="primary" ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify'
import BarChart from '../operational/BarChart.js'

export default {
    name: 'eventtoepisodestats',
    components: {
        BarChart,
    },
    data () {
        return {
            isNotDashboard: true,
            loading: false,
            graphdata: '',
            selectLength: '1 Hour',
            selectCount: 1,
            IInterval: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            statCall: 'Episode Count',
            tableinfo: {length: "", interval:""},
            ILength: [
                        '15 Minutes',
                        '1 Hour',
                        '1 Day',
                        '1 Week',
                        '2 Weeks',
                        '1 Month'
                    ],
            statType: [ 'Episode Count', 'Event Count', 'Events per Episode', 'Hijack Count', 'Episode Length (seconds)', 
                        'Prefix Count', 'Episodes per Prefix', 'New Prefix Count', 'Path Change Count'
                    ,   'Restricted Prefix Count', 'Restricted DNS Count', 'Controlled Prefix Count', 'Bogon Count', 'Route Leak Count'],
            slider: {
                intervalLengthSeconds: 0,
                intervalCount: 0
            },
            headinfo: 'Interval Length Minutes',
            bodyinfo:   `1 Hour - 60 Minutes,
                        12 Hours - 720 Minutes,
                        1 Day - 1440 Minutes,
                        2 Days - 2880 Minutes,
                        3 Days - 4320 Minutes,
                        1 Week - 10080,
                        1 Month - 40320`,
            options: {
                tooltips: {
                    titleFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10, 
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                },
                title: {
                    display: true,
                    fontSize: 16
                },
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    },
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Count',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 0,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            display: false
                        }
                    }]
                }
        },
        }
    },
    props: {
        sampleGraph: String,
    },
    beforeMount() {
        if(this.sampleGraph) {
            this.selectCount = 7
            this.selectLength = '1 Day'
            this.statCall = this.sampleGraph
            this.tableinfo.length = this.selectLength
            this.tableinfo.interval = this.selectCount
            this.isNotDashboard = false
            this.options.scales.yAxes[0].display = false;
            this.getdata(this.sampleGraph, this.selectLength, this.selectCount)
        }
    },

    methods: {
        getdata:  async function () {
            this.loading=true;
            try {

            
                var length = 0;
                var name = '';
                if (this.selectLength == '15 Minutes'){
                    length = 900
                } else if (this.selectLength == '1 Hour'){
                    length = 3600
                } else if (this.selectLength == '1 Day'){
                    length = 86400
                } else if (this.selectLength == '1 Week'){
                    length = 604800
                } else if (this.selectLength == '2 Weeks'){
                    length = 1209600
                } else if (this.selectLength == '1 Month'){
                    length = 2419200
                }
                this.tableinfo.interval = this.selectCount

                if (this.statCall == 'Episode Count'){
                    name = "total_episode_count"
                } else if (this.statCall == 'Event Count'){
                    name = "total_event_count"
                } else if (this.statCall == 'Events Per Episode'){
                    name = "mean_events_per_episode"
                } else if (this.statCall == 'Hijack Count'){
                    name = "hijack_count"
                } else if (this.statCall == 'Episode Length (seconds)'){
                    name = "avg_episode_length"
                } else if (this.statCall == 'Prefix Count'){
                    name = "unique_prefix_count"
                } else if (this.statCall == 'Episodes per Prefix'){
                    name = "episodes_for_prefix"
                } else if (this.statCall == 'New Prefix Count'){
                    name = "first_obs_count"
                } else if (this.statCall == 'Path Change Count'){
                    name = "path_change_count"
                } else if (this.statCall == 'Restricted DNS Count'){
                    name = "restricted_dns_count"
                } else if (this.statCall == 'Controlled Prefix Count'){
                    name = "controlled_prefix_count"
                } else if (this.statCall == 'Bogon Count'){
                    name = "bogon_count"
                } else if (this.statCall == 'Route Leak Count'){
                    name = "route_leak_count"
                }

            
                var query = `query getEpisodeStatsAll { getScoredEpisodeStats (interval_length_seconds:  `+length+`, interval_count: `+this.selectCount+`, page_offset: 0, page_rows:`+length+`) {
                    interval_start
                    `+name+`
                    } 
                }`
                console.log(query)

                var labelName = this.statCall



                const episodeStats = await API.graphql(graphqlOperation(query));
                var data = episodeStats.data.getScoredEpisodeStats
                console.log(data)
                var graphdata = { labels: [labelName], datasets: [] }

                for (var i =0; i< data.length; i = i+1){
                    var date = new Date(data[i].interval_start * 1000)
                    var time = date.toGMTString()
                    var date2 = date.getUTCDate() + "/" + (date.getUTCMonth() +1) + "/" + date.getUTCFullYear()
                    var datelabel = date2 + time.substr(16, 9) + " + " + this.selectLength 
                    var dataset =   {label: [datelabel], data: [data[i][name]],
                                    fill: false, borderColor: '#6400aa', backgroundColor: '#6400aa',
                                    pointHitRadius: '2', pointBorderWidth: '5'}
                    graphdata.datasets.push(dataset)

                }
                this.tableinfo.length = this.selectLength;


                //     pointHoverBorderWidth: '4',
                this.graphdata = graphdata

                this.loading=false

            }
        
        catch (err) {
            this.loading = false;
            console.log(err)
            this.message = "An error has occured, please try again later."

            }
        }
    }
}
</script>
